import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";

const PurchaseRequestFields = ({
  form,
  handleChange,
  error,
  setDrIds,
  drIds,
  data,
  getDepartment = [],
}) => {
  const drawingData =
    useSelector((state) => state?.getDrawing?.user?.data) || [];
  const requestedByData =
    useSelector((state) => state.getGenMaster?.user?.data) || [];
  const projectData =
    useSelector((state) => state.getProject?.user?.data) || [];
  const getPaymentData =
    useSelector((state) => state?.getPaymentList?.user?.data?.list) || [];
  const quotationData =
    useSelector((state) => state?.getQuotationData?.user?.data) || [];

  // const selectedProject = projectData.find((p) => p._id === form.project_id);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Project <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.project_id}
              options={projectData?.map((e) => ({
                label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "project_id", value: e.value } })
              }
              placeholder="Select Project"
              filter
              className="w-100"
            />
            <div className="error">{error?.project_id_err}</div>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Project No</label>
            <input
              type="text"
              name="manual_pro_no"
              placeholder="Enter Project No"
              value={form?.manual_pro_no || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Drawing</label>
            <MultiSelect
              value={drIds}
              options={drawingData
                ?.filter((p) => p.project?._id === form.project_id)
                ?.map((p) => ({ label: p.drawing_no, value: p._id }))}
              onChange={(e) => setDrIds(e.value)}
              filter
              maxSelectedLabels={3}
              disabled={form.project_id ? false : true}
              className="w-100 multi-prime-react"
              optionLabel="label"
              placeholder="Select Drawings"
            />
            <div className="error">{error?.drawing_id_err}</div>
          </div>
        </div>
        {data?._id && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>PR No.</label>
              <input
                type="text"
                className="form-control"
                value={data?.voucher_no}
                readOnly
              />
            </div>
          </div>
        )}

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Quotation No</label>
            <Dropdown
              value={form.quotation_id}
              options={quotationData?.map((e) => ({
                label: e.voucher_no,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "quotation_id", value: e.value },
                })
              }
              placeholder="Select Quotation No"
              filter
              className="w-100"
            />
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Payment Method <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.payment_method_id}
              options={getPaymentData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "payment_method_id", value: e.value },
                })
              }
              placeholder="Select Payment Method"
              filter
              className="w-100"
            />
            {error.payment_err && (
              <div className="error">{error.payment_err}</div>
            )}
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Requested By <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.master_id}
              options={requestedByData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "master_id", value: e.value } })
              }
              placeholder="Select Requested By"
              filter
              className="w-100"
            />
            {error.master_id && <div className="error">{error.master_id}</div>}
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="trans_date"
              onChange={handleChange}
              value={form.trans_date}
            />
            {error.trans_date && (
              <div className="error">{error.trans_date}</div>
            )}
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Expected Delivery Date </label>
            <input
              type="date"
              className="form-control"
              name="exp_delivery_date"
              onChange={handleChange}
              value={form.exp_delivery_date}
            />
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Department </label>
            <Dropdown
              value={form.department_id}
              options={getDepartment?.map((d) => ({
                label: d.name,
                value: d._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "department_id", value: e.value },
                })
              }
              showClear
              filter
              placeholder="Select Department"
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 ">
          <div className="input-block local-forms">
            <label>Reason/Purpose</label>
            <textarea
              type="text"
              className="form-control"
              rows={4}
              onChange={handleChange}
              name="remarks"
              placeholder="Remarks"
              value={form.remarks}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseRequestFields;
